var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabBar"},_vm._l((_vm.tabs),function(link,index){return _c('router-link',{key:'tab' + index,staticClass:"tab-item",attrs:{"tag":"button","to":link.path}},[_c('i',{staticClass:"icon ignore",class:'icon-' + link.icon}),_c('span',{staticClass:"f-s13"},[_vm._v(_vm._s(link.title))])])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f89be10","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav-bar/index.vue
// module id = null
// module chunks = 